import { useMediaQuery } from "@mui/material";
import dayjs from "dayjs";
import { EditableDataGrid } from "../../../builderPackage/components/editableDataGrid/editableDataGrid";
import { useAppSelector } from "../../../store/hooks";
import { vehicleHistoryKeys } from "../service/entity";
export var CustomerHistoryCatalogView = function (props) {
    var _crud$vehicleHistoryK;
    var value = props.value, error = props.error, _a = props.name, name = _a === void 0 ? 'IBCustomerDetails' : _a;
    var crud = useAppSelector(function (state) { return state.crud; });
    var isDesktop = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var pagingColumns = [{
            field: 'Customername',
            headerName: 'Customer name',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.Customername ? "".concat(row === null || row === void 0 ? void 0 : row.Customername) : '-'; },
            minWidth: isDesktop ? 460 : 240
        }, {
            field: 'EffectiveFROM',
            headerName: 'Effective from date',
            valueFormatter: function (val, row) {
                if (row !== null && row !== void 0 && row.EffectiveFROM) {
                    var EffectiveFROMDate = row !== null && row !== void 0 && row.EffectiveFROM ? dayjs.utc(row === null || row === void 0 ? void 0 : row.EffectiveFROM).format('DD MMM, YYYY') : '-';
                    return EffectiveFROMDate;
                }
                else {
                    return "-";
                }
            },
            minWidth: isDesktop ? 460 : 240
        }, {
            field: 'EffectiveTo',
            headerName: 'Effective to date',
            valueFormatter: function (val, row) {
                if (row !== null && row !== void 0 && row.EffectiveTo) {
                    var EffectiveToDate = row !== null && row !== void 0 && row.EffectiveTo ? dayjs.utc(row.EffectiveTo).format('DD MMM, YYYY') : '-';
                    return EffectiveToDate;
                }
                else {
                    return '-';
                }
            },
            minWidth: isDesktop ? 469 : 250
        }];
    return /*#__PURE__*/ React.createElement(EditableDataGrid, {
        dataGridHeader: "Ownership details",
        isCollapsible: true,
        columns: pagingColumns,
        disableAddRow: true,
        disableDeleteRow: true,
        dataGridProps: {
            checkboxSelection: false,
            disableRowSelectionOnClick: true,
            hideFooter: true
        },
        rows: ((_crud$vehicleHistoryK = crud[vehicleHistoryKeys.SeviceHistoryKey]) === null || _crud$vehicleHistoryK === void 0 || (_crud$vehicleHistoryK = _crud$vehicleHistoryK.data) === null || _crud$vehicleHistoryK === void 0 ? void 0 : _crud$vehicleHistoryK.IBCustomerDetails) || [],
        error: error === null || error === void 0 ? void 0 : error[name]
    });
};
